<template>
    <div ref="cascaderItem" class="cascaderItem">
        <div class="left">
            <div class="label" :key="index" v-for="(item,index) in list" @click="setList(item)">
                {{item.name}}
                <template v-if="loadingVisible(item)">
                    <g-icon class="loading"  icon="loading"></g-icon>
                </template>
                <template v-else>
                    <g-icon v-if="rightArrowVisible(item)" icon="right"></g-icon>
                </template>
            </div>
        </div>
        <div class="right" v-if="rightList">
            <g-cascader-popover :loading-item="loadingItem" :load-data="loadData" :selectList="selectList" :level="level+1" :list="rightList"></g-cascader-popover>
        </div>
    </div>
</template>

<script>
import Icon from '../icon'
export default {
    name: 'g-cascader-popover',
    components: {
        'g-icon': Icon
    },
    props: {
        list: {
            type: Array
        },
        level: {
            type: Number,
            default: 0
        },
        selectList: {
            type: Array
        },
        loadData: {
            type: Function
        },
        loadingItem: {
            type: Object,
            defalut: () => {
                return {}
            }
        }
    },
    computed: {
        rightList() {
            if(this.selectList[this.level]){
                const item =  this.list.filter(item => {
                    return item.id == this.selectList[this.level].id
                })[0]
                if(item && item.children) {
                    return item.children
                }else {
                    return null
                }
            }else{
                return null
            }
            // const list = this.selectList[this.level]
            // if(list) {
            //     return list.children
            // }else {
            //     return null
            // }
        }
    },
    methods: {
        setList(item) {
            this.eventBus.$emit('change',this.level,item)
        },
        rightArrowVisible(item) {
            return this.loadData ? !item.isLeaf : item.children
        },
        loadingVisible(item) {
            return this.loadingItem.name === item.name
        }
    },
    inject: ['eventBus']
}
</script>

<style lang="scss" scoped>
@import '../var';
.cascaderItem {
    display: flex;
    height: 204px;
    > .left {
        padding: 0.3em 0;
        background: #fff;
        height: 100%;
        overflow: auto;
        &::-webkit-scrollbar{
            width:10px;
            height:10px;
        }
        &::-webkit-scrollbar-track{
            background: rgb(239, 239, 239);
            border-radius:2px;
        }
        &::-webkit-scrollbar-thumb{
          background: #bfbfbf;
          border-radius:10px;
        }
        &::-webkit-scrollbar-thumb:hover{
          background: #333;
        }
        &::-webkit-scrollbar-corner{
          background: #179a16;
        }
        > .label {
            padding: 0.3em 1em;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            white-space: nowrap;
            &:hover{
                background:$grey;
            }
            > .icon {
                margin-left: 1em;
                &.loading{
                    animation: spin 2s infinite linear;
                }
            }
        }
    }
    > .right {
        height: 100%;
        border-left: 1px solid $border-color-light;
        overflow: auto;
    }
}
</style>